<page-header [title]="l('Notifications')">
</page-header>
<nz-card [nzBordered]="false">
    <form nz-form [nzLayout]="'vertical'" class="search__form">
        <nz-row nzGutter="8">
            <nz-col nzSm="12">
                <nz-form-item>
                    <nz-form-control>
                        <nz-range-picker name="DateRange" [(ngModel)]="dateRange" class="width-100">
                        </nz-range-picker>
                    </nz-form-control>
                </nz-form-item>
            </nz-col>
            <nz-col nzSm="12">
                <nz-form-item>
                    <nz-form-control>
                        <nz-select style="width: 100%;" [(ngModel)]="readStateFilter" (ngModelChange)="onSearch()"
                            name="ReadStateFilter">
                            <nz-option nzValue="ALL" [nzLabel]="l('All')"></nz-option>
                            <nz-option nzValue="UNREAD" [nzLabel]="l('Unread')"></nz-option>
                        </nz-select>
                    </nz-form-control>
                </nz-form-item>
            </nz-col>
        </nz-row>
    </form>
    <nz-row nzGutter="8">
        <nz-col nzMd="20" nzSm="12">
            <button nz-button [nzType]="'default'" (click)="openNotificationSettingsModal()">
                <i nz-icon nzType="setting"></i>
                <span>
                    {{"NotificationSettings" | localize}}
                </span>
            </button>
            <button nz-button [nzType]="'primary'" (click)="setAllNotificationsAsRead()">
                <i nz-icon nzType="check"></i>
                <span>
                    {{"SetAllAsRead" | localize}}
                </span>
            </button>
        </nz-col>
    </nz-row>
    <nz-row class="my-md">
        <nz-table #ajaxTable [nzData]="dataList" [nzTotal]="totalItems" [(nzPageIndex)]="pageNumber"
            [(nzPageSize)]="pageSize" [nzLoading]="isTableLoading" (nzPageIndexChange)="pageNumberChange()"
            (nzPageSizeChange)="refresh()" [nzShowSizeChanger]="true" [nzShowQuickJumper]="true"
            [nzShowTotal]="totalTemplate" [nzFrontPagination]="false">
            <ng-template #totalTemplate let-total>
                {{'TotalRecordsCount' | localize:total}}
            </ng-template>
            <thead (nzSortOrderChange)="gridSort($event)">
                <tr>
                    <th>
                        {{'Notification' | localize}}
                    </th>
                    <th>
                        {{'CreationTime' | localize}}
                    </th>
                    <th nzWidth="200px" class="text-center">
                        {{'Actions' | localize}}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of ajaxTable.data">
                    <td>
                        <a *ngIf="item.formattedNotification.url" href="{{item.formattedNotification.url}}">{{truncateString(item.formattedNotification.text,
                            120)}}</a>
                        <span *ngIf="!item.formattedNotification.url" title="{{item.formattedNotification.text}}">{{truncateString(item.formattedNotification.text,
                            120)}}</span>
                    </td>
                    <td>
                        <span nz-tooltip [nzTooltipTitle]="item.notification.creationTime | luxonFormat:'ffff'">
                            {{ item.notification.creationTime | luxonFromNow }}
                        </span>
                    </td>

                    <td class="text-center">
                        <ng-container *ngIf="!isRead(item)">
                            <a (click)="setAsRead(item)">
                                <i nz-icon nzType="check"></i>
                                {{'SetAsRead' | localize}}
                            </a>
                            <nz-divider nzType="vertical"></nz-divider>
                        </ng-container>
                        <ng-container>
                            <a nz-popconfirm [nzPopconfirmTitle]="l('NotificationDeleteWarningMessage')"
                                (nzOnConfirm)="deleteNotification(item)" [nzOkText]="l('Ok')"
                                [nzCancelText]="l('Cancel')">
                                <i nz-icon nzType="delete"></i>
                                {{'Delete' | localize}}
                            </a>
                        </ng-container>
                    </td>
                </tr>
            </tbody>
        </nz-table>
    </nz-row>
</nz-card>
